// src/components/dashboard/charts/plotTheme.js

export const chartFont =
  "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial";

export const premiumPalette = {
  yes: "#6366F1", // indigo-500
  no: "#06B6D4",  // cyan-500
  text: "rgba(15, 23, 42, 0.92)",
  subtext: "rgba(15, 23, 42, 0.62)",
  grid: "rgba(15, 23, 42, 0.06)",
  axis: "rgba(15, 23, 42, 0.14)",
  tooltipBg: "rgba(2, 6, 23, 0.92)",
  tooltipBorder: "rgba(255,255,255,0.10)",
};

export function premiumLayout() {
  return {
    autosize: true,
    template: null,

    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",

    margin: { l: 50, r: 16, t: 10, b: 64 },

    font: { family: chartFont, size: 12, color: premiumPalette.text },

    hovermode: "x unified",
    hoverlabel: {
      bgcolor: premiumPalette.tooltipBg,
      bordercolor: premiumPalette.tooltipBorder,
      font: { family: chartFont, size: 12, color: "#fff" },
      align: "left",
      namelength: -1,
    },

    // redondeo moderno (si tu plotly lo soporta, se verá; si no, lo ignora)
    barcornerradius: 10,

    xaxis: {
      automargin: true,
      showgrid: false,
      zeroline: false,
      ticks: "",
      showline: false,
      tickfont: { size: 11, color: premiumPalette.subtext },
    },
    yaxis: {
      automargin: true,
      showgrid: true,
      gridcolor: premiumPalette.grid,
      zeroline: false,
      ticks: "",
      showline: false,
      tickfont: { size: 11, color: premiumPalette.subtext },
    },

    legend: {
      orientation: "h",
      x: 0,
      y: 1.22,
      xanchor: "left",
      yanchor: "top",
      bgcolor: "rgba(0,0,0,0)",
      font: { size: 11, color: premiumPalette.subtext },
      itemclick: "toggleothers",
      itemdoubleclick: "toggle",
    },

    transition: { duration: 250, easing: "cubic-in-out" },
  };
}

export const premiumConfig = {
  displayModeBar: false,
  displaylogo: false,
  responsive: true,
};